"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocationColumn = exports.locationColumnSchema = void 0;
var yup = require("yup");
var ColorHSL_1 = require("./ColorHSL");
var LocationShelve_1 = require("./LocationShelve");
exports.locationColumnSchema = yup.object().shape({
    id: yup.string().optional(),
    color: yup.lazy(function (value) {
        return typeof value === "object"
            ? ColorHSL_1.colorHSLSchema.required("Required field").typeError("Required field")
            : yup.string().oneOf(["transparent"]).required("Required field");
    }),
    shelves: yup.array().of(LocationShelve_1.locationShelveSchema).required(),
});
function isLocationColumn(obj) {
    return exports.locationColumnSchema.isValidSync(obj);
}
exports.isLocationColumn = isLocationColumn;
